import { useMemo, useRef } from 'react';
export const entityLimits = {
    defaultThrottleDuration: 3000,
    minWakeUptime: 1440,
};
export const useBufferedThrottle = (value, callback, throttleDuration = entityLimits.defaultThrottleDuration) => {
    const buffer = useRef([]);
    const lastRan = useRef(Date.now());
    useMemo(() => {
        if (value) {
            buffer.current.push(value);
        }
        const handler = setTimeout(() => {
            if (Date.now() - lastRan.current >= throttleDuration) {
                callback(buffer.current);
                lastRan.current = Date.now();
                buffer.current = [];
            }
        }, throttleDuration - (Date.now() - lastRan.current));
        return () => {
            clearTimeout(handler);
        };
    }, [value, throttleDuration]);
};
//# sourceMappingURL=useBufferedThrottle.js.map